module.exports = __webpack_public_path__ + "static/banner-245a219a781c88f072624ab47644781d.jpg";